module.exports = __webpack_public_path__ + "phone.png?555038adee84560059dc7782e2f6c243";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone.png
// module id = 114
// module chunks = 0